import useApiClient from "../../useApiClient";
import { useSelector } from "react-redux";
import { useCallback } from "react";
import * as jsonpatch from "fast-json-patch";
import { withNetworkErrorHandling } from "../../helpers/withNetworkErrorHandling";

const useUserAPIClient = () => {
  const { get, update } = useApiClient();
  const { activeUser } = useSelector((state) => state.user);

  const getUser = useCallback(async () => {
    return await withNetworkErrorHandling(() =>
      get(`users/${activeUser.userId}`),
    );
  }, [activeUser, get]);

  const setMindset = useCallback(
    async (mindset) => {
      const patches = jsonpatch.compare(activeUser, { ...activeUser, mindset });
      return await withNetworkErrorHandling(() =>
        update(`users/${activeUser.userId}`, patches),
      );
    },
    [activeUser, update],
  );

  const setSortPreference = useCallback(
    async (sortPreference) => {
      const patches = jsonpatch.compare(activeUser, {
        ...activeUser,
        sortPreference,
      });
      return await withNetworkErrorHandling(() =>
        update(`users/${activeUser.userId}`, patches),
      );
    },
    [activeUser, update],
  );

  const setTimezone = useCallback(
    async (timezone) => {
      const patches = jsonpatch.compare(activeUser, {
        ...activeUser,
        timezone,
      });
      return await withNetworkErrorHandling(() =>
        update(`users/${activeUser.userId}`, patches),
      );
    },
    [activeUser, update],
  );

  const setTaskCreationPreference = useCallback(
    async (taskCreationPreference) => {
      const patches = jsonpatch.compare(activeUser, {
        ...activeUser,
        taskCreationPreference,
      });
      return await withNetworkErrorHandling(() =>
        update(`users/${activeUser.userId}`, patches),
      );
    },
    [activeUser, update],
  );

  return { getUser, setMindset, setSortPreference, setTimezone, setTaskCreationPreference };
};

export default useUserAPIClient;
